import React from 'react'
import './MyDonations.css'

function MyDonations() {
  return (
    <div className='MyDonations'>

    </div>
  )
}

export default MyDonations